import React from "react";
import { motion } from "framer-motion";
import * as Dialog from "@radix-ui/react-dialog";

/**
 * Historical patch notes data, newest first.
 * @type {Array<{version: string, date: string, notes: Array<string>}>}
 */
export const PATCHES = [
  {
    version: "v1.2.89",
    date: "June 27th, 2026",
    notes: [
      "hotfix for a few wrong data set entries / typos in trivia and music",
    ],
  },
  {
    version: "v1.2.8",
    date: "June 1st, 2026",
    notes: [
      "hotfix for quote mode not counting the correct character",
      "hotfix for factions mode resetting seat counts",
      "reset faction points in the leaderboard as the counting bugged out. but it will count correctly from now on and load your stats on page load to retroactively add your points to the leaderboard",
    ],
  },
  {
    version: "v1.2.7",
    date: "May 30th, 2026",
    notes: [
      "fixed bug where the arcus theme didn't show red dots in the day replay calendar",
      "fixed a Loose/Win detection bug which was messing with some people's profile stats",
      "added auto focus on search bar when clicking on a game mode so you can start typing immediately",
      "hopefully fixed a bug where browsers on iOS would crash when zooming on the silhouette page",
      "as the poll was mostly in favour of the change, the Craft mode now shows the craft name and you have to guess the character that uses it (the global comparison for the past dates still showing the craft name is intended)",
    ],
  },
  {
    version: "v1.2.6",
    date: "May 25th, 2026",
    notes: [
      "changed all music titles that said Trails in the Sky to Trails in the Sky FC for better search results",
      "added a Factions mode (will only count starting 1st of June). check out the tab for the rules and earn badges in your collection :D",
      "added 30 more locations and made some of them a bit harder to guess, as Locations mode was very easy until now",
    ],
  },
  {
    version: "v1.2.5",
    date: "May 23rd, 2026",
    notes: [
      "added a Map View in the collection menu for locations. Some don't really have coordinates on the Zermurian map, so I had to put them in random places but hope you like it anyway :)",
    ],
  },
  {
    version: "v1.2.4",
    date: "May 23rd, 2026",
    notes: [
      "Hotfix for todays trivia regarding Schera and Luciola showing the correct answer when picked",
      "added Thors affiliation to Celestin",
      "removed the Lapis trivia question to not appear again in the future, I can't remove it from the past now unfortunately",
    ],
  },
  {
    version: "v1.2.3",
    date: "May 16th, 2026",
    notes: [
      "We now officially migrated from free hosting to proper domain hosting with more capacity",
      "With this we also now officially have our own domain name: kisekidle.app <3",
      "Streamlined the Roadmap a little to make it more organized and give a proper overview of what we'll be doing next",
      "Some more UI updates here and there :)",
    ],
  },
  {
    version: "v1.2.2",
    date: "May 14th, 2026",
    notes: [
      "Added a toggle in the settings to disable the rotating bg images and have static colour instead",
      "Implemented another fix for the rotating bg images not appearing for everyone",
      "Updated some of the character squares so they fit the format of the others better",
      "Added a toggle in the settings you can check to auto expand all the collection dropdowns",
      "Added completion bars in the collection mode - 1. for overall at the top 2. per mode 3. per game in each mode",
    ],
  },
  {
    version: "v1.2.1",
    date: "May 11th, 2026",
    notes: [
      "Fixed legacy sidebar dividers and brightened sky status labels.",
      "Fixed search result list not loading properly for some people",
      "Hopefully fixed rotating bg images not loading for some people",
      "Fixed the confetti not working properly anymore",
      "We got some new, cool logos for the new themes <3",
      "You can now toggle HUD scanlines on/off in Settings for the Xipha and ARCUS themes",
    ],
  },
  {
    version: "v1.2.0",
    date: "May 10th, 2026",
    notes: [
      "I have been playing around with a tool for making UIs and I overhauled the legacy UI for both desktop and mobile - hope it looks better now :)",
      "I also added 3 themed UIs in the settings menu as a fun little side-project, hope you like them!",
      "With this patch we have also officially fixed every reported bug! (at least in my own testing lol) - except for that persistent bug of recalculating stats only being 98% accurate >_>",
      "That means we can focus on adding content now, *if* nothing else comes up :D",
    ],
  },
  {
    version: "v1.1.9",
    date: "May 7th, 2026",
    notes: [
      "I had to trim the search results in all categories to 15 results to prevent the game from loading too many images at once and causing massive requests when typing",
      "Added some behind-the-scenes logic to make the game more stable and prevent accidental double-syncing with the server.",
      "Added a Ko-fi link to the sidebar if you'd like to support the project and help with the hosting costs as I do want to add more images and music and the free hosting might not suffice for long <3",
      "But I want to emphasize that this is not mandatory at all! The hosting costs are only a few bucks per month so we can easily carry it ourselves",
      "",
    ],
  },
  {
    version: "v1.1.8",
    date: "May 5th, 2026",
    notes: [
      "quick hot fix to make Linde also Erebonian instead of Unknown and adding classes to the affiliations for some Thors students so they aren't all green",
      "this change will not be visible in already finished games, you'll only see it next time!",
      "fixed an issue with the Recalculate Stats button where it would incorrectly give 100% win rates for Music/Crafts modes and wrong stats for Silhouette mode.",
    ],
  },
  {
    version: "v1.1.7",
    date: "May 3rd, 2026",
    notes: [
      "Collection Overhaul is finally live - please check it out! Profiles & Collections are now two separate, dedicated menus in the sidebar",
      "Collections got a big UI/UX overhaul. Entries are grouped by Game (or Nation for Locations) with a collapsible UI and everything except trivia is clickable for usage stats in that category",
      "another fix for profile mode so hopefully now it really tracks everything correctly for all metrics.",
      "Added a 'Recalculate Stats' button in Profile/Settings to scan your entire play history and rebuild your profile&collection data (hopefully) accurately.",
      "some minor tweaks to trivia questions",
    ],
  },
  {
    version: "v1.1.6",
    date: "May 2nd, 2026",
    notes: [
      "I had a very productive time yesterday and today so I was able to add/change a lot of things :D",
      "Finally added the character squares everyone wanted like in the OG!",
      "Also added the ability to click on them in the collection to see more info like in the OG",
      "Made a few UI/UX changes like getting rid of the legacy switch in the sidebar that almost no-one was using anyway and some other changes to make the game a little easier to read and use",
      "fixed the profile page so now it tracks everything correctly hopefully",
      "I will also push another patch live later today or tomorrow overhauling the collection to show every category not just characters",
    ],
  },
  {
    version: "v1.1.5",
    date: "April 30th, 2026",
    notes: [
      "added a button in music mode so you can choose if you want the track to play from the beginning or at a random point - beware this choice will be saved per daily puzzle and will only reset the next day!",
      "changed the crafts mode a little: Gender hint is gone, debut game hint now activates after 2 wrong guesses, you can see the debut game of each craft in the search results now next to the character name. This should make the crafts mode a little easier but not too easy",
    ],
  },
  {
    version: "v1.1.4",
    date: "April 25th, 2026",
    notes: [
      "added rotating background wallpapers like the OG had (we are aware that some will not look perfect with certain screen resolutions - will look into that later)",
      "Added 125 wallpapers (now eyes are spinning from so many open picture tabs (°_o) lol - will add more in future)",
      "Added 50 more quotes as well :)",
    ],
  },
  {
    version: "v1.1.3",
    date: "April 24th, 2026",
    notes: [
      "added progress badges to the sidebar like the OG had",
      "Added 40 more music tracks",
    ],
  },
  {
    version: "v1.1.2",
    date: "April 23rd, 2026",
    notes: [
      "added exclusion of already used search terms, so if you search for a character/track/location that you already guessed, it won't show up in the search results anymore",
      "added predicted age range for some characters like the OG had",
      "swapped all roman numerals in the game titles to numbers for better searching and consistency",
      "fixed a few typos in the character names and other minor things",
    ],
  },
  {
    version: "v1.1.1",
    date: "April 19th, 2026",
    notes: [
      "added 70 more silhouettes with different artworks to make it more difficult to guess the character hopefully",
      "added a Poll feature so we can ask you guys questions if we have one :)",
    ],
  },
  {
    version: "v1.1.0",
    date: "April 19th, 2026",
    notes: [
      "quick fix for location and crafts mode's search bar not working",
      "fixed scrolling issue on mobile",
      "implemented a better search prioritising for the search results",
    ],
  },
  {
    version: "v1.0.9",
    date: "April 18th, 2026",
    notes: [
      "Fixed the trivia streak being stuck at 1",
      "fixed issues with the mobile layout",
      "fixed issue where hitting Enter wouldn't quick select the first entry in the search results",
    ],
  },
  {
    version: "v1.0.8",
    date: "April 18th, 2026",
    notes: [
      "fixed a typo so it says Chaton now instead of Chanton",
      "fixed Shanshan's age to not be Unknown (thank you to the person sending me the link to the conversation as proof :D)",
      "censored some of the craft descriptions to make it less easy to know the answer immediately lol",
      "added a Roadmap button in the menu",
    ],
  },
  {
    version: "v1.0.7",
    date: "April 17th, 2026",
    notes: [
      "qhick fix to make Feri an accepted answer. Ith should be counted as correct now for all the people who reported it",
    ],
  },
  {
    version: "v1.0.6",
    date: "April 13th, 2026",
    notes: [
      "Hello everyone, thanks a lot for all the feedback and reports! Makes us glad people are enjoying <3",
      "added 1 more quote which got requested :)",
      "fixed link in the share results",
      "added the option of sharing all results either as emojis or text in the 'Todays Results' screen",
      "added Streak function",
      "you can now use the arrow keys and Enter for the search list, so you don't need to use the mouse",
    ],
  },
  {
    version: "v1.0.5",
    date: "April 12th, 2026",
    notes: ["added 13 more trivia questions :)"],
  },
  {
    version: "v1.0.4",
    date: "April 12th, 2026",
    notes: [
      "fixed an issue where some characters' age didn't show as a match correctly even though it was the same number",
    ],
  },
  {
    version: "v1.0.3",
    date: "April 12th, 2026",
    notes: [
      "fixed an issue where some players could see all the answers in the global comparison modal without finishing",
    ],
  },
  {
    version: "v1.0.2",
    date: "April 12th, 2026",
    notes: [
      "fixed an issue which would make the image in silhouette mode visible",
    ],
  },
  {
    version: "v1.0.1",
    date: "April 12th, 2026",
    notes: [
      "Fixed 2 typos in the Trivia dataset",
      "fixed a typo in Laura's name leading to her not being accepted as the correct answer",
      "changed a few craft descriptions so the gender isn't revealed",
    ],
  },
  {
    version: "v1.0.0",
    date: "April 12th, 2026",
    notes: ["🎉 Welcome to the official launch of the revived Kisekidle!"],
  },
];

/**
 * Radix dialog listing all Kisekidle patch notes (v1.0.0 through current) with
 * staggered framer-motion animations for each entry.
 *
 * @param {{ onClose: () => void, currentTheme: string }} props
 * @param {() => void} props.onClose - Callback to dismiss the dialog.
 * @param {string} props.currentTheme - Active era theme name for styling.
 * @returns {JSX.Element} The patch notes modal.
 */
export default function PatchNotesModal({ onClose, currentTheme }) {
  return (
    <Dialog.Root open={true} onOpenChange={(open) => !open && onClose()}>
      <Dialog.Portal>
        <Dialog.Overlay forceMount asChild>
          <motion.div
            className={`modal-overlay theme-${currentTheme}`}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          />
        </Dialog.Overlay>
        <div className={`modal-content-wrapper theme-${currentTheme}`}>
          <Dialog.Content forceMount asChild>
            <motion.div
              className="modal-content patch-notes-box"
              initial={{ y: 50, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              exit={{ y: 50, opacity: 0 }}
            >
              <Dialog.Title className="sr-only">Patch Notes</Dialog.Title>
              <Dialog.Description
                style={{
                  marginBottom: "20px",
                  textAlign: "center",
                  opacity: 0.8,
                }}
              >
                History of updates and changes to Kisekidle.
                <br />
                <br />
                As work has been very busy recently T_T Patches will now only
                come on weekends (except for hotfixes).
                <br />
                Thank you for your understanding &lt;3
              </Dialog.Description>

              <Dialog.Close asChild>
                <button className="modal-close">✖</button>
              </Dialog.Close>
              <h2
                className="mode-title"
                style={{ textAlign: "center", marginBottom: "20px" }}
              >
                📝 Patch Notes
              </h2>

              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "15px",
                }}
              >
                {PATCHES.map((patch, index) => (
                  <motion.div
                    key={index}
                    className="patch-entry"
                    initial={{ opacity: 0, y: 15 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{
                      duration: 0.4,
                      delay: index * 0.08,
                      ease: "easeOut",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "baseline",
                        marginBottom: "10px",
                      }}
                    >
                      <h3 style={{ margin: 0 }}>{patch.version}</h3>
                      <span style={{ fontSize: "0.85rem", opacity: 0.7 }}>
                        {patch.date}
                      </span>
                    </div>
                    <ul
                      style={{
                        textAlign: "left",
                        paddingLeft: "30px",
                        marginTop: "10px",
                      }}
                    >
                      {patch.notes.map((note, noteIndex) => (
                        <li
                          key={noteIndex}
                          style={{ marginBottom: "8px", lineHeight: "1.4" }}
                        >
                          {note}
                        </li>
                      ))}
                    </ul>
                  </motion.div>
                ))}
              </div>
            </motion.div>
          </Dialog.Content>
        </div>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
